export const VoteMixin = {
  computed: {
    allVotes() {
      return {
        Yes: this.$t("views.government.vote.yes"),
        No: this.$t("views.government.vote.no"),
        EH: this.$t("views.government.vote.abstain"),
        ES: this.$t("views.government.vote.excused"),
        NT: this.$t("views.government.vote.not_there"),
        P: this.$t("views.government.vote.president")
      };
    }
  },
  methods: {
    getVoteColor(decision) {
      switch (decision) {
        case "Yes":
          return "#7FB59F";
        case "No":
          return "#7A7A7A";
        default:
          return "var(--interaction-dark)";
      }
    },
    getVoteLabel(decision) {
      return this.allVotes[decision] || "";
    }
  }
};
